import { useContext } from 'react';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import type { CustomizeClosestVehicle } from '~/contracts/new-cars';

// TODO: Remove this hook when the API stops returning closestVehicle unless it's a perfect match.
export default function useClosestVehicle(): CustomizeClosestVehicle | null {
  const { customizeOptions, selectedOptions } = useContext(ParentModelContext);

  const { closestVehicle } = customizeOptions.data;

  const driveTypeMatches =
    closestVehicle?.driveType?.name === selectedOptions?.driveType;
  const engineMatches =
    closestVehicle?.engine?.code === selectedOptions?.engineCode;
  const exteriorColorMatches =
    closestVehicle?.exteriorColor?.code === selectedOptions?.exteriorColorCode;
  const interiorColorMatches =
    closestVehicle?.interiorColor?.code === selectedOptions?.interiorColorCode;
  const packageOptionsMatch = closestVehicle?.packageOptions?.every(
    packageOption =>
      selectedOptions?.packageOptionCodes?.includes(packageOption.code)
  );

  return closestVehicle &&
    driveTypeMatches &&
    engineMatches &&
    exteriorColorMatches &&
    interiorColorMatches &&
    packageOptionsMatch
    ? closestVehicle
    : null;
}
